import React from 'react'

export default function PaymentFailedPayU() {
    return (
        <div>
            <div className="payment-container">
                <div className="payment-card">
                    {/* Success Icon */}
                    <div className="success-icon">
                        <svg
                            className="crossmark"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 52 52"
                        >
                            <circle
                                className="crossmark-circle"
                                cx="26"
                                cy="26"
                                r="25"
                                fill="none"
                            />
                            <path
                                className="crossmark-cross"
                                fill="none"
                                d="M16 16 36 36 M36 16 16 36"
                            />
                        </svg>

                    </div>

                    {/* Title */}
                    <h1>Payment Failed!</h1>
                    {/* <p>
                        Your subscription is now active. Please open the app to explore and enjoy premium OTT content without interruptions.
                    </p> */}

                    {/* Order Details */}
                    <div className="order-details">
                        <p style={{ whiteSpace: "wrap", textAlign: "center" }}><strong>Order ID:</strong> {window.location.href?.split('/')?.[4] || "N/A"}</p>
                        {/* <p><strong>Amount Paid:</strong> ₹10</p> */}
                        {/* <p><strong>Payment Method:</strong> Cashfree</p> */}
                    </div>

                    {/* Actions */}
                    {/* <div className="actions">
                    <button className="btn btn-primary">Download Receipt</button>
                    <button className="btn btn-secondary">Continue Shopping</button>
                </div> */}
                </div>
            </div>
        </div>
    )
}
